import React from 'react';

import { Heading, Body } from '@depop/web-thrift-ui/Typography';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

export function ShopErrorMessage() {
  const t = useTranslations('common');

  return (
    <div className={styles.container}>
      <Heading variant="sm" className={styles.title} as="p">
        {t('500.Message')}
      </Heading>
      <Body variant="sm-regular">{t('PleaseTryAgain')}</Body>
    </div>
  );
}
